import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { motion } from "framer-motion";
import { CommentOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  List,
  Modal,
  Progress,
  Rate,
  Row,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteRequest, getRequest, postRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import address from "../../assets/images/address.svg";
import mail from "../../assets/images/email.svg";
import lockIcon from "../../assets/images/lockIcon.png";
import phoneIc from "../../assets/images/Phone-Icon.svg";
import watsapp from "../../assets/images/watsapp.svg";
import Website from "../../assets/images/website.svg";
import facebook from "../../assets/newImages/facebook.svg";
import instagram from "../../assets/newImages/Insta.svg";
import Linkedin from "../../assets/newImages/Linkedin.svg";
import tiktok from "../../assets/newImages/tiktok.svg";
import twitter from "../../assets/newImages/x.svg";
import youtubeIc from "../../assets/newImages/youtube.svg";
import Loader from "../../components/Loader/Loader";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import {
  setContactTabValue,
  setDesignation,
} from "../../Reducer/localStorageSlice";
import ComponentListSubTabsComponent from "./newUx/subTabs/ComponenListSubTabs";
import "./contactUs.scss";
import { gtag } from "../../utils/util";

const socialMediaArray = [
  {
    linkKey: "linkedInLink",
    img: Linkedin,
    label: "Linkedin",
  },
  {
    linkKey: "twitterLink",
    img: twitter,
    label: "X",
  },
  {
    linkKey: "youtubeLink",
    img: youtubeIc,
    label: "Youtube",
  },
  {
    linkKey: "instagramLink",
    img: instagram,
    label: "Instagram",
  },
  {
    linkKey: "tiktokLink",
    img: tiktok,
    label: "Tik-Tok",
  },
  {
    linkKey: "facebookLink",
    img: facebook,
    label: "Facebook",
  },
];

const salesArray = [
  {
    linkKey: "phone",
    img: phoneIc,
    label: "Phone",
    href: "tel:",
  },
  {
    linkKey: "email",
    img: mail,
    label: "Email",
    href: (data) =>
      `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
        data?.email || ""
      )}`,
  },
  {
    linkKey: "chatNumber",
    img: watsapp,
    label: "Whatsapp",
    href: "mailto:",
    text: true,
  },
  {
    linkKey: "websiteLink",
    img: Website,
    label: "Website",
  },
  {
    linkKey: "postalAddress",
    img: address,
    label: "Address",
    text: true,
  },
];

const careerArray = [
  {
    linkKey: "phone",
    img: phoneIc,
    label: "Phone",
    href: "tel:",
  },
  {
    linkKey: "email",
    img: mail,
    label: "Email",
    href: (data) =>
      `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
        data?.email || ""
      )}`,
  },
  {
    linkKey: "chatNumber",
    img: watsapp,
    label: "Whatsapp",
    href: "mailto:",
    text: true,
  },
  {
    linkKey: "websiteLink",
    img: Website,
    label: "Website",
  },
];

function ContactUsComponent({missingTabs}) {
  const dispatch = useDispatch();
  const color = ["#FF8A00", "#FF4D4F", "#FADB14", "#1890FF", "#52C41A"];

  const location = useLocation();
  const [modalVisible, setModalVisible] = useState(false);
  const [replyFormOpen, setReplyFormOpen] = useState({});

  const reduxGlobalState = useSelector((state) => state.global);
  const localData = useSelector((state) => state?.localStorage);
  const {
    designation,
    ageID,
    micrositeID,
    "contact-tabValue": contactTabValue,
    accessToken,
  } = localData;

  useEffect(() => {
    const userDesignation = reduxGlobalState?.userProfile?.tag?.userTag;
    if (userDesignation) {
      dispatch(setDesignation(userDesignation));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reduxGlobalState?.userProfile?.tag?.userTag]);

  const handleDeleteReply = async (replyId) => {
    const token = accessToken;
    try {
      const response = await deleteRequest(
        userapiservice.deleteReview(replyId),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response) {
        toast.success(
          <ToastComponent
            type={"Success"}
            message={`Review deleted successfully `}
          />
        );
        setModalVisible(false);
        getReviewData();
      }
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={`Error deleting reply:, ${error}`}
        />
      );
    }
  };

  const toggleReplyForm = (reviewId) => {
    setReplyFormOpen((prevState) => ({
      ...prevState,
      [reviewId]: !prevState[reviewId],
    }));
  };

  const [contactUsKey, setContactUsKey] = useState(
    contactTabValue || "REVIEWS"
  );
  const [responseData, setReponseData] = useState([]);
  const [ReviewData, setReviewData] = useState([]);

  const isSmallScreen = useMediaQuery({ minWidth: 320, maxWidth: 767 });
  const age = localData?.age;

  const access = accessToken || "";

  const navigate = useNavigate();
  const [, setLoading] = useState(true);
  const id = micrositeID;

  const phoneNumberWithCountryCode =
    reduxGlobalState?.userProfile?.phoneNumber || "";

  const getContactusData = async (activeKey, id) => {
    setReponseData([]);
    try {
      setLoading(true);
      if (id) {
        const response = await getRequest(
          userapiservice.getContactUsDetails(id, contactUsKey)
        );
        if (response) {
          setReponseData(response);
          if (activeKey === "SALES") {
            // setSalesLocation([response[0]?.lat || 0, response[0]?.lng || 0]);
          } else if (activeKey === "HUMAN_RESOURCE") {
            // setHrLocation([response[0]?.lat || 0, response[0]?.lng || 0]);
          } else {
            // setEowLocation([response[0]?.lat || 0, response[0]?.lng || 0]);
          }

          setLoading(false);
        }
      }
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={error?.error || "Something went wrong"}
        />
      );

      setLoading(false);
    }
  };

  const getReviewData = async () => {
    try {
      setLoading(true);
      const response = await getRequest(
        userapiservice.getReviews(id, phoneNumberWithCountryCode),
        {},
        false
      );
      setReviewData(response);
      setLoading(false);
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={error?.error || "Something went wrong"}
        />
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (contactUsKey !== "REVIEWS") {
      getContactusData(contactUsKey, id);
    }
    // contactUsChangeTab()
    if (contactUsKey === "REVIEWS") getReviewData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactUsKey, id]);

  const calculateAverageRating = () => {
    if (ReviewData.length === 0) return 0;

    const totalRating = ReviewData.reduce((sum, item) => sum + item.rating, 0);
    const averageRating = totalRating / ReviewData.length;

    return Number(averageRating);
  };
  const avgrate = calculateAverageRating();

  const calculateRatingDistribution = () => {
    if (ReviewData.length === 0) {
      return {};
    }

    const ratingCounters = {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
    };

    ReviewData.forEach((item) => {
      const roundedRating = Math.floor(item.rating);
      ratingCounters[roundedRating] += 1;
    });

    const totalCount = ReviewData.length;

    const ratingPercentages = {
      1: (ratingCounters[1] / totalCount) * 100,
      2: (ratingCounters[2] / totalCount) * 100,
      3: (ratingCounters[3] / totalCount) * 100,
      4: (ratingCounters[4] / totalCount) * 100,
      5: (ratingCounters[5] / totalCount) * 100,
    };

    return ratingPercentages;
  };

  const ratingPercentages = calculateRatingDistribution();

  const changeContactUsTab = (tabValue) => {
    gtag("event", "tab_click", {
      tab_name: tabValue,
      // tab_name: 'Sales',
    });

    dispatch(setContactTabValue(tabValue));
    setContactUsKey(tabValue);
  };

  const [rating, setRating] = useState(2.5);
  const [document, setDocuments] = useState();
  const [Rew, setRew] = useState("");
  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  const handleReviewChange = useCallback((e) => {
    setRew(e.target.value);
  }, []);

  const handleSubmit = async (e) => {
    const url = userapiservice.addReview();

    const requestBody = {
      mobileNumber: phoneNumberWithCountryCode,
      isPartnerApproved: true,
      description: Rew,
      rating: rating,
      micrositeId: id,
    };

    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const response = await postRequest(url, requestBody, headers);

      // Handle the response data here if needed
      if (response?.id) {
        toast.success(
          <ToastComponent
            type={"Success"}
            message={`Review Submitted Successfully`}
          />
        );

        setRating(0);
        setRew("");
        getReviewData();
      }
    } catch (error) {
      // Handle errors here
      console.error("Error:", error);
    }
  };
  const value = avgrate;

  const getFiles = async () => {
    try {
      const response = await getRequest(userapiservice.getFiles(micrositeID));
      if (response) {
        setDocuments(response);
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (access.length > 1) {
      getFiles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const callContactViewAPI = async (micrositeId, tabEnum) => {
    if (ageID !== "3923bb48-79f8-4a9e-98f8-b604137197cc") {
      try {
        const headers = {
          Authorization: `Bearer ${accessToken}`,
        };
        const res = await postRequest(
          userapiservice.contactPageViewCount(micrositeId, tabEnum),
          headers
        );
        if (res) {
          if (tabEnum === "SALES") {
            sessionStorage.setItem("salesView", "viewed");
          } else if (tabEnum === "HUMAN_RESOURCE") {
            sessionStorage.setItem("hrView", "viewed");
          } else if (tabEnum === "EXPERIENCES_OF_WORK") {
            sessionStorage.setItem("eowView", "viewed");
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const micrositeId = micrositeID;

  useEffect(() => {
    if (contactUsKey === "SALES") {
      const tabCount = sessionStorage.getItem("salesView");
      if (tabCount !== "viewed") {
        callContactViewAPI(micrositeId, "SALES");
      }
    } else if (contactUsKey === "HUMAN_RESOURCE") {
      const tabCount = sessionStorage.getItem("hrView");
      if (tabCount !== "viewed") {
        callContactViewAPI(micrositeId, "HUMAN_RESOURCE");
      }
    } else if (contactUsKey === "EXPERIENCES_OF_WORK") {
      const tabCount = sessionStorage.getItem("eowView");
      if (tabCount !== "viewed") {
        callContactViewAPI(micrositeId, "EXPERIENCES_OF_WORK");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactUsKey]);

  const SocialMediaRender = ({ activeSubKey, activeSubArray }) => {
    const isDelayedRef = useRef(false);
    const [, forceUpdate] = useReducer((x) => x + 1, 0);

    useEffect(() => {
      const timer = setTimeout(() => {
        isDelayedRef.current = true;
        forceUpdate();
      }, 500);

      return () => clearTimeout(timer);
    }, []);

    if (!isDelayedRef.current) {
      return (
        <div
          className="social-media-container"
          style={{ textAlign: "center", width: "100%" }}
        >
          <Loader />
        </div>
      );
    }
    return (
      <div
        className="social-media-container"
        style={{ width: !responseData.length > 0 && "100%" }}
      >
        <Row className="social-media-icons">
          {contactUsKey === activeSubKey &&
          responseData &&
          responseData.length > 0 ? (
            responseData.map((data) => {
              const filteredLinks = activeSubArray.filter((item) => data[item.linkKey]);
              return (
                <React.Fragment key={data.id}>
                {filteredLinks?.map((item, index) => (
                  <div
                    key={item.linkKey}
                    style={{
                      width: "33%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      padding: "7px",
                      boxSizing: "border-box",
                    }}
                  >
                    <img
                      className="social-media-icons-image"
                      src={item?.img}
                      alt={item?.label?.toLowerCase()}
                      // title={data[item?.linkKey]}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                      // title={data[item?.linkKey]}
                      onClick={() => {
                        const link = data[item?.linkKey];

                        // simple regex to validate URL
                        const isValidUrl = /^(http|https):\/\/[^ "]+$/.test(
                          link
                        );

                        if (isValidUrl) {
                          window.open(link, "_blank", "noopener,noreferrer");
                        } else {
                          // fallback to #
                          window.open("#", "_self");
                          console.warn(
                            "Invalid link, opened fallback (#):",
                            link
                          );
                          toast.error(
                            <ToastComponent
                              type=" "
                              message="Sorry, link not available at the moment"
                            />
                          );
                        }
                      }}
                      style={{
                        width: "100%",
                        height: "auto",
                        maxWidth: "85px",
                      }}
                    />
                  </div>
                ))}
              </React.Fragment>
              )
            })
          ) : (
            <div className="background-container" style={{ width: "100%" }}>
              <div className="login-wall">
                <div className="info-container">
                  <span>No contact details available at the moment</span>
                </div>
              </div>
            </div>
          )}
        </Row>
      </div>
    );
  };

  const AddressRender = () => {
    if (!responseData || responseData.length === 0) {
      return (
        <div className="background-container" style={{ width: "100%" }}>
          <div className="login-wall">
            <div className="info-container">
              <span>No address data available.</span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="card-list-container">
        <div className="card-container">
          {responseData.map((entry, i) => {
            const outputs = Array.isArray(entry.addressOutputs)
              ? entry.addressOutputs
              : [];

            // If no addressOutputs, use postal
            if (outputs.length === 0) {
              const postal = entry.postalAddress;

              return (
                <motion.div
                  key={entry.id}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{
                    duration: 0.8,
                    delay: 0.3,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                  className="card-item"
                >
                  <div className="text-container-contact-us">
                    <div className="card-title">
                      {postal || "No address available for this entry."}
                    </div>
                  </div>

                  <div
                    className="color-band"
                    style={{ backgroundColor: "#ccc" }}
                  />

                  {/* <div className="image-container">
                      <div className="media">
                        <div className="slider-Img"></div>
                      </div>
                    </div> */}
                </motion.div>
              );
            }

            // If multiple address outputs
            return outputs.map((out) => {
              const street = out?.street?.toString().trim();
              const key = `${entry.id}-${out?.id}`;

              return (
                <motion.div
                  key={key}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{
                    duration: 0.8,
                    delay: 0.3,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                  className="card-item"
                >
                  <div className="text-container-contact-us">
                    <div className="card-title">
                      {street ||
                        "No address available for this address output."}
                    </div>
                  </div>

                  <div
                    className="color-band"
                    style={{ backgroundColor: color[i % color?.length] }}
                  />

                  {/* <div className="image-container">
                      <div className="media">
                        <div className="slider-Img"></div>
                      </div>
                    </div> */}
                </motion.div>
              );
            });
          })}
        </div>
      </div>
    );
  };

  const SubTabRender = ({ activeSubKey, activeSubArray }) => {
    return (
      <div className="content">
        <Row className="rowBody">
          <Col xs={24} md={24} xl={24}>
            <div className="tableRowCol2">
              {contactUsKey === activeSubKey &&
              responseData &&
              responseData.length > 0 ? (
                responseData.map((data) => (
                  <React.Fragment key={data.id}>
                    {activeSubArray?.map((item) =>
                      item.linkKey === "postalAddress" ? null : ( // 👈 skip postalAddress
                        <div className="tableRow" key={item.linkKey}>
                          <div className="tableCol">
                            <div className="infoRow">
                              <div className="infoCol">
                                <img
                                  src={item?.img}
                                  alt={item?.label?.toLowerCase()}
                                />
                              </div>
                              <div className="infoCol">
                                <label>{item?.label}</label>
                              </div>
                            </div>
                          </div>
                          <div className="tableCol">
                            {!item?.text && (
                              <a
                                href={
                                  typeof item?.href === "function"
                                    ? item?.href(data)
                                    : data?.[item?.linkKey]
                                    ? data[item.linkKey].startsWith("http")
                                      ? data[item.linkKey]
                                      : `https://${data[item.linkKey]}`
                                    : "#"
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                {data?.[item?.linkKey] || "No link available"}
                              </a>
                            )}
                            {item?.text && (
                              <Col className="gutter-row" span={18}>
                                {data[item?.linkKey] || "none"}
                              </Col>
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </React.Fragment>
                ))
              ) : (
                <div className="background-container" style={{ width: "100%" }}>
                  <div className="login-wall">
                    <div className="info-container">
                      <span>No contact details available at the moment</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div className="background-container" style={{ width: "100%" }}>
      <ComponentListSubTabsComponent
        data={[
          {
            title: "Reviews",
            key: "REVIEWS",
            component: (
              <>
                {access ? (
                  <>
                    <div className="ratingNdReview">
                      <div className="ratingBars">
                        <div>
                          <div style={{ marginBottom: 10 }}>
                            <div style={{ fontSize: 25, fontWeight: "bold" }}>
                              {avgrate.toFixed(2)}
                            </div>
                            <Rate
                              value={value}
                              disabled
                              style={{ fontSize: 15 }}
                              allowHalf
                            />
                            <div style={{ fontSize: 10 }}>
                              ({ReviewData.length})
                            </div>
                          </div>
                          <div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="progressBarContainer">
                                <span className="progressNumber">5</span>
                                <Progress
                                  className="progressBar"
                                  percent={ratingPercentages[5]}
                                  format={(percent) => `${percent.toFixed(2)}%`}
                                  showInfo={false}
                                />
                              </div>
                              <div className="progressBarContainer">
                                <span className="progressNumber">4</span>
                                <Progress
                                  className="progressBar"
                                  percent={ratingPercentages[4]}
                                  format={(percent) => `${percent.toFixed(2)}%`}
                                  showInfo={false}
                                />
                              </div>
                              <div className="progressBarContainer">
                                <span className="progressNumber">3</span>
                                <Progress
                                  className="progressBar"
                                  percent={ratingPercentages[3]}
                                  format={(percent) => `${percent.toFixed(2)}%`}
                                  showInfo={false}
                                />
                              </div>
                              <div className="progressBarContainer">
                                <span className="progressNumber">2</span>
                                <Progress
                                  className="progressBar"
                                  percent={ratingPercentages[2]}
                                  format={(percent) => `${percent.toFixed(2)}%`}
                                  showInfo={false}
                                />
                              </div>
                              <div className="progressBarContainer">
                                <span className="progressNumber">1</span>
                                <Progress
                                  className="progressBar"
                                  percent={ratingPercentages[1]}
                                  format={(percent) => `${percent.toFixed(2)}%`}
                                  showInfo={false}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="reviewForm">
                        {age > 18 ? (
                          <Form
                            onFinish={handleSubmit}
                            style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Form.Item
                              style={{ marginBottom: "10px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Description is required",
                                },
                              ]}
                            >
                              <label
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  textAlign: "left",
                                  marginRight: "20px",
                                }}
                              >
                                Rate us
                              </label>
                              {/* Assuming you have a Rate component */}
                              <Rate
                                allowHalf
                                value={rating}
                                onChange={handleRatingChange}
                                defaultValue={rating}
                              />
                            </Form.Item>
                            <Form.Item style={{ marginBottom: "10px" }}>
                              <label
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  textAlign: "left",
                                }}
                              >
                                Write us a Review
                              </label>
                              <Input.TextArea
                                placeholder="Enter Review"
                                value={Rew}
                                onChange={handleReviewChange}
                                style={{
                                  width: "100%",
                                  minHeight: !isSmallScreen ? "95px" : "100px",
                                  borderRadius: "5px",
                                  resize: "none",
                                }}
                                maxLength={100}
                              />
                            </Form.Item>
                            <Form.Item
                              style={{
                                alignSelf: "flex-end",
                                marginTop: "10px",
                              }}
                            >
                              <Button
                                className="submit-button"
                                htmlType="submit"
                                style={{
                                  borderRadius: "5px",
                                  backgroundColor: "#569dfa",
                                  color: "white",
                                }}
                              >
                                Submit
                              </Button>
                            </Form.Item>
                          </Form>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    <div>
                      <div style={{ padding: 10, paddingTop: 0 }}>
                        <List
                          dataSource={ReviewData}
                          renderItem={(item) => (
                            <div>
                              <div>{item.description}</div>
                              <Rate
                                allowHalf
                                value={item.rating}
                                disabled
                                style={{ fontSize: 15 }}
                              />
                              {item.replies && item.replies.length > 0 && (
                                <Button
                                  type="link"
                                  icon={<CommentOutlined />}
                                  onClick={() => toggleReplyForm(item.id)}
                                  style={{ marginLeft: 10 }}
                                />
                              )}
                              {item.mobileNumber ===
                                phoneNumberWithCountryCode && (
                                <>
                                  <Modal
                                    title="Delete Review"
                                    visible={modalVisible}
                                    onCancel={() => setModalVisible(false)}
                                    footer={[
                                      <Button
                                        key="cancel"
                                        onClick={() => setModalVisible(false)}
                                      >
                                        Cancel
                                      </Button>,
                                      <Button
                                        key="delete"
                                        // type="primary"
                                        style={{
                                          backgroundColor: "red",
                                          color: "white",
                                        }}
                                        onClick={() =>
                                          handleDeleteReply(item.id)
                                        }
                                      >
                                        Delete
                                      </Button>,
                                    ]}
                                  >
                                    <p>
                                      Are you sure you want to delete this
                                      review?
                                    </p>
                                  </Modal>
                                  <Button
                                    onClick={() => {
                                      setModalVisible(true);
                                    }}
                                    type="link"
                                    style={{ marginLeft: 10 }}
                                    icon={<DeleteOutlined />}
                                  />
                                </>
                              )}
                              {replyFormOpen[item.id] && (
                                <div>
                                  {item.replies && item.replies.length > 0 && (
                                    <List
                                      style={{ marginLeft: 20 }}
                                      dataSource={item.replies}
                                      renderItem={(reply, index) => (
                                        <div>
                                          <div>
                                            <p style={{ fontWeight: 600 }}>
                                              reply from the organization:{" "}
                                            </p>
                                            {reply.description}
                                          </div>
                                          {index < item.replies.length - 1 && (
                                            <hr
                                              style={{
                                                borderColor: "lightgray",
                                                opacity: 0.3,
                                              }}
                                            />
                                          )}
                                        </div>
                                      )}
                                    />
                                  )}
                                </div>
                              )}
                              <hr
                                style={{
                                  borderColor: "lightgray",
                                  opacity: 0.5,
                                }}
                              />
                            </div>
                          )}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <div
                    className="info-container"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      flexGrow: "1",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <img src={lockIcon} alt="Partner Logo" />
                    <span className="text-to-contact-info">
                      Login to view contact information
                    </span>
                    <span
                      style={{ color: "#3067AE" }}
                      className="text-to-contact-info"
                      onClick={() =>
                        navigate("/login", {
                          state: {
                            id,
                            page: "microsite",
                            from: `${location?.pathname}`,
                          },
                        })
                      }
                    >
                      Register/Login
                    </span>
                  </div>
                )}
              </>
            ),
          },
          {
            title: "Social media",
            key: "SOCIAL_MEDIA",
            component: (
              <SocialMediaRender
                activeSubKey="SOCIAL_MEDIA"
                activeSubArray={socialMediaArray}
              />
            ),
          },
          {
            title: "Sales",
            key: "SALES",
            component: (
              <SubTabRender activeSubKey="SALES" activeSubArray={salesArray} />
            ),
          },
          {
            title: "Customer services",
            key: "CUSTOMER_SERVICES",
            component: (
              <SubTabRender
                activeSubKey="CUSTOMER_SERVICES"
                activeSubArray={salesArray}
              />
            ),
          },
          {
            title: "Careers",
            key: "HUMAN_RESOURCE",
            component: (
              <SubTabRender
                activeSubArray={careerArray}
                activeSubKey="HUMAN_RESOURCE"
              />
            ),
          },
          {
            title: "Contracts",
            key: "CONTRACTS",
            component: (
              <SubTabRender
                activeSubKey="CONTRACTS"
                activeSubArray={salesArray}
              />
            ),
          },
          {
            title: "Experiences of work",
            key: "EXPERIENCES_OF_WORK",
            component: (
              <div
                className={`${responseData?.length === 0 ? "exp-of-work" : ""}`}
              >
                <div className="content">
                  <Row className="rowBody">
                    <Col className="gutter-row tabContent contactTab" span={24}>
                      <div className="tableRowCol2">
                        {contactUsKey === "EXPERIENCES_OF_WORK" &&
                        responseData &&
                        responseData.length > 0 ? (
                          responseData.map((data) => {
                            return (
                              <>
                                {data.phone && (
                                  <div className="tableRow">
                                    <div className="tableCol">
                                      <div className="infoRow">
                                        <div className="infoCol">
                                          <img src={phoneIc} alt="phone"></img>
                                        </div>
                                        <div className="infoCol">
                                          <label style={{ marginLeft: "3px" }}>
                                            {" "}
                                            Phone
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tableCol">
                                      <a href={"tel:" + data.phone}>
                                        {data.phone}
                                      </a>
                                    </div>
                                  </div>
                                )}
                                {data.email && (
                                  <div className="tableRow">
                                    <div className="tableCol">
                                      <div className="infoRow">
                                        <div className="infoCol">
                                          <img src={mail} alt="mail"></img>
                                        </div>
                                        <div className="infoCol">
                                          <label style={{ marginLeft: "3px" }}>
                                            Email
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tableCol">
                                      <a
                                        href={`https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
                                          data.email
                                        )}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {data.email}
                                      </a>
                                    </div>
                                  </div>
                                )}
                                {data.chatNumber && (
                                  <div className="tableRow">
                                    <div className="tableCol">
                                      <div className="infoRow">
                                        <div className="infoCol">
                                          <img
                                            src={watsapp}
                                            alt="watsapp"
                                          ></img>
                                        </div>
                                        <div className="infoCol">
                                          <label style={{ marginLeft: "3px" }}>
                                            Whatsapp
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tableCol">
                                      <a
                                        href={`https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
                                          data.email
                                        )}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {data.chatNumber}
                                      </a>
                                    </div>
                                  </div>
                                )}
                                {data.websiteLink && (
                                  <div className="tableRow">
                                    <div className="tableCol">
                                      <div className="infoRow">
                                        <div className="infoCol">
                                          <img
                                            src={Website}
                                            alt="website"
                                          ></img>
                                        </div>
                                        <div className="infoCol">
                                          <label style={{ marginLeft: "3px" }}>
                                            Website
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tableCol">
                                      <a
                                        href={
                                          data?.websiteLink
                                            ? data.websiteLink.startsWith("http")
                                              ? data.websiteLink
                                              : `https://${data.websiteLink.replace(/^undefined/, "")}`
                                            : undefined
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                          if (!data?.websiteLink) {
                                            e.preventDefault();
                                          }
                                        }}
                                      >
                                        {data?.websiteLink ||
                                          "No link available"}
                                      </a>
                                    </div>
                                  </div>
                                )}
                                {data.postalAddress && (
                                  <div className="tableRow">
                                    <div className="tableCol">
                                      <div className="infoRow">
                                        <div className="infoCol">
                                          <img
                                            src={address}
                                            alt="address"
                                          ></img>
                                        </div>
                                        <div className="infoCol">
                                          <label style={{ marginLeft: "3px" }}>
                                            Address
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tableCol">
                                      {data.postalAddress}
                                    </div>
                                  </div>
                                )}

                                {(responseData.length > 0 &&
                                  designation === "Lecturer") ||
                                designation === "Teacher" ? (
                                  <div className="download-container">
                                    <a
                                      href={document?.filePath}
                                      download={document?.filePath}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <Button className="download-btn btn btn-danger">
                                        Download Insurance
                                      </Button>
                                    </a>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                          })
                        ) : (
                          <div
                            className="background-container"
                            style={{ width: "100%" }}
                          >
                            <div className="login-wall">
                              <div className="info-container">
                                <span>
                                  No contact details available at the moment
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            ),
          },
          {
            title: "Volunteering",
            key: "VOLUNTEERING",
            component: (
              <SubTabRender
                activeSubKey="VOLUNTEERING"
                activeSubArray={salesArray}
              />
            ),
          },
          {
            title: "Addresses",
            key: "ADDRESS",
            component: <AddressRender />,
          },
        ]?.filter((d)=> {
            if(missingTabs?.length){
                return !missingTabs?.some((m)=> m === d?.key)
            }
            return true
        })}
        activeKey={contactUsKey}
        handleSubTabChange={changeContactUsTab}
      />
    </div>
  );
}

export default ContactUsComponent;
